import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { getLocationCoordinates } from "../../services/utils/helpers";
import widgetMapperInitialData from "./dashboardWidgetMapper";
import { useDispatch } from "react-redux";
import { checkIfPrivacyPolicyAccepted } from "../../actions/licence";
import { getProjectsStatusesData } from "../../actions/bcfData";
import { Responsive } from "react-grid-layout";
import "react-resizable/css/styles.css";
import "react-grid-layout/css/styles.css";
import css from "./portaldashboard.module.css";
import { convertDate } from "../../services/luxonHelper";
import { ThemeContext } from "../../ProviderApp";
import { THEME_LIGHT } from "../../App.constant";
import noProjectdata from "../../assets/images/noPortalData.svg";
import { setShowStickySidebar, setSidebarSelectedCell } from "../../actions/stickySidebar";
import axiosWrapper from "../../services/axiosWrapper";
import DashboardWidgetCard from "./dashboardWidgetCard";
import EmbeddedLink from "../../cubeComponent/dashboardComponents/EmbeddedLink";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import "./index.css";
import IconComponent from "@CubeComponents/icons";
import _ from "lodash";

const useDashboard = ({
  projectId = null,
  portalLayout,
  projectDashboardData,
  portalDashboardData,
  userDetails = {},
  width,
}) => {
  const { t } = useTranslation();
  const themeContext = useContext(ThemeContext);
  const [triggerSign, setTriggerSign] = useState(false);
  const [widgetDataFiltered, setWidgetDataFiltered] = useState({});
  const [saveWidget, setSaveWidget] = useState(false);
  const [isWidgetModalVisible, setIsWidgetModalVisible] = useState(false);
  const [dragListavailableData, setDragListavailableData] = useState([]);
  const [dragListselectedData, setDragListselectedData] = useState([]);
  const [setWeatherDetails, setSetWeatherDetails] = useState({});
  const [latLong, setLatLong] = useState("");
  const [widgetMapper, setWidgetMapper] = useState({});
  const [gridLayout, setGridLayout] = useState([]);
  const [saveLayout, setSaveLayout] = useState({});
  const [onLayoutSave, setOnLayoutSave] = useState(false);
  const [initialRenderDone, setInitialRenderDone] = useState(false);
  const [isStatic, setStatic] = useState(true);
  const [isConfigureModalVisible, setIsConfigureModalVisible] = useState(false);
  const [border, setBorder] = useState(true);
  const [modalData, setModalData] = useState({});
  const dispatch = useDispatch();

  const tempBlockForCpwd = ["techm-dev", "techm-prod", "techm-preprod"].includes(process.env.REACT_APP_ENV);

  useEffect(() => {
    if (projectId) {
      setModalData(projectDashboardData);
    } else {
      setModalData(portalDashboardData);
    }
  }, [portalDashboardData, projectDashboardData]);

  useEffect(() => {
    if (!tempBlockForCpwd && latLong) {
      weatherDetails();
    }
  }, [latLong]);

  useEffect(() => {
    if (triggerSign !== false) {
      document.getElementById("signForm").action = triggerSign.url;
      document.getElementById("Parameter1").value = encodeURI(triggerSign.params.Parameter1);
      document.getElementById("Parameter2").value = encodeURI(triggerSign.params.Parameter2);
      document.getElementById("Parameter3").value = encodeURI(triggerSign.params.Parameter3);
      document.getElementById("signForm").submit();
    }
  }, [triggerSign]);

  const getWeatherDiv = () =>
    setWeatherDetails.current ? (
      <div className={css.timeDateWrapper}>
        <img src={setWeatherDetails.current?.condition?.icon} alt="No Image" />
        <div className={css.portalTime}>
          <span className={css.timee} data-testid="portalDashboardTemp">
            {setWeatherDetails.current?.feelslike_c}
            &ordm;
          </span>
          <span className={css.timeZone} data-testid="portalDashboardLocation">
            {`${setWeatherDetails.location?.name},${setWeatherDetails.location?.country}`}
          </span>
        </div>
      </div>
    ) : null;

  useEffect(() => {
    if (Object.keys(portalLayout).length) {
      fetchUserSettings();
    }
  }, [portalLayout]);

  useEffect(() => {
    if (!projectId) {
      borderFunction();
    }
  }, [widgetMapper]);

  function borderFunction() {
    Object.keys(widgetMapper).map((widgetName, index) => {
      if (index == 0) {
        setBorder(widgetMapper[widgetName].isAdded);
      } else if (index != 0 && widgetMapper[widgetName].isAdded) {
        setBorder(true);
      }
    });
  }

  const init = async () => {
    if (["development", "qa", "prod", "staging"].includes(process.env.REACT_APP_ENV) && !projectId) {
      dispatch(checkIfPrivacyPolicyAccepted());
    }
    if (projectId) {
      dispatch(setSidebarSelectedCell("Home"));
      dispatch(setShowStickySidebar(true));
      dispatch(getProjectsStatusesData());
    }
    if (!tempBlockForCpwd) {
      const coordinateResponse = await getLocationCoordinates();
      setLatLong(coordinateResponse.join(","));
    }
  };

  useEffect(() => {
    init();
  }, []);

  const getDate = () => {
    const date = convertDate(new Date(), "dateForPortalDashboard");
    return date;
  };

  const handleWidgetMapperChange = (data) => {
    setWidgetMapper(data);
    setSaveWidget(true);
  };

  const fetchUserSettings = async () => {
    let payload = {
      type: "DASHBOARD_LAYOUT",
    };
    if (projectId) {
      payload = {
        type: "PROJECT_DASHBOARD_LAYOUT",
        resourceId: projectId,
      };
    }
    const response = await axiosWrapper.post(`${getBackendUrl()}/userSettings/getUserSettings`, payload);

    const widgetData = widgetMapperInitialData({
      layout: portalLayout,
      projectId,
    });

    if (response.data.data) {
      for (const data of response.data.data.value) {
        if (!data.type) {
          if (Object.hasOwn(widgetData, data.name)) {
            widgetData[data.name].isAdded = data.isAdded;
            widgetData[data.name].layout = data.layout;
            if (data.name == "QuickLinksTile") {
              const tempDataObj = {};
              const selectedDataTempObj = {};
              Object.keys(widgetData[data.name].selectedData).map((widgetAvailableDataKey) => {
                if (data.availableData.includes(widgetAvailableDataKey)) {
                  tempDataObj[widgetAvailableDataKey] = widgetData[data.name].selectedData[widgetAvailableDataKey];
                } else if (data.selectedData.includes(widgetAvailableDataKey)) {
                  selectedDataTempObj[widgetAvailableDataKey] =
                    widgetData[data.name].selectedData[widgetAvailableDataKey];
                }
              });
              widgetData[data.name].availableData = tempDataObj;
              widgetData[data.name].selectedData = selectedDataTempObj;
            }
          }
        } else {
          widgetData[Math.random()] = {
            component: EmbeddedLink,
            expand: true,
            ...data,
            allowIn: projectId ? ["PROJECT"] : ["PORTAL"],
            propertiesOption: [{ id: "", text: "Remove" }],
          };
        }
      }
    }

    if (!projectId) {
      if (!userDetails.company?.id) {
        delete widgetData.QuickLinksTile.availableData.OrgSettingsData;
        delete widgetData.QuickLinksTile.selectedData.OrgSettingsData;
      }
      setDragListavailableData(Object.values(widgetData.QuickLinksTile.availableData));
      setDragListselectedData(Object.values(widgetData.QuickLinksTile.selectedData));
    }

    setWidgetDataFiltered(widgetData);
    setWidgetMapper(widgetData);
    const tempLayout = Object.keys(widgetData).map((item) => widgetData[item].layout);
    setGridLayout(tempLayout);
  };

  const weatherDetails = () => {
    const latLongValue = latLong || "0";
    axiosWrapper.post(`${getBackendUrl()}/portal/weather/${latLongValue}`).then((response) => {
      const weatherResposne = response.data.data;
      setSetWeatherDetails(weatherResposne);
    });
  };

  const handleClick = () => {
    setStatic(!isStatic);
    if (onLayoutSave) {
      setWidgetMapper(saveLayout);
      setSaveWidget(true);
    } else {
      setStatic(!isStatic);
      setWidgetMapper(widgetMapper);
    }
  };

  const layoutChangeFunction = (layout) => {
    if (!layout.length) {
      return false;
    }
    if (!initialRenderDone) {
      setInitialRenderDone(true);
      return false;
    }
    const data = _.cloneDeep(widgetMapper);
    {
      !isStatic &&
        layout.forEach((layoutData) => {
          const layoutName = layoutData.i.split("_")[0];
          data[layoutName].layout = {
            w: layoutData.w,
            x: layoutData.x,
            y: layoutData.y,
            h: layoutData.h,
          };
        });
    }
    setSaveLayout(data);
    setOnLayoutSave(true);
  };

  const getLockUnlockIconRender = () => {
    let icon = "Unlock";
    if (isStatic) {
      icon = "Lock";
    }
    return <IconComponent name={icon} onClick={handleClick} />;
  };

  const refreshPage = () => {
    window.location.reload();
  };

  const getWidgetCard = ({ widget, widgetName, isModalVisible }) => (
    <DashboardWidgetCard
      widget={widget}
      widgetName={widgetName}
      isModalVisible={isModalVisible}
      widgetMapper={widgetMapper}
      graphIssuesDataByStatus={{}}
      widgetDataFiltered={widgetDataFiltered}
      setWidgetMapper={setWidgetMapper}
      setSaveWidget={setSaveWidget}
      setIsConfigureModalVisible={setIsConfigureModalVisible}
      saveWidget={saveWidget}
      setWidgetDataFiltered={setWidgetDataFiltered}
      projectId={projectId}
    />
  );

  const defaultLayoutFunction = () => {
    const getEmbeddedLink = {};
    for (const embeddedWidget in widgetMapper) {
      if (widgetMapper[embeddedWidget].type == "EMBEDDED_LINK") {
        getEmbeddedLink[embeddedWidget] = {
          ...widgetMapper[embeddedWidget],
          isAdded: false,
        };
      }
    }
    const data = widgetMapperInitialData({ projectId, layout: portalLayout });
    setWidgetMapper({ ...data, ...getEmbeddedLink });
    setStatic(true);
    setSaveWidget(true);
    // refreshPage();
  };

  const handleSignClick = async () => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/digitalSignature/sign`);
    setTriggerSign(response.data.data);
  };

  const getResposiveGrid = () => (
    <>
      <div className={css.editWidgetsWrapper}>
        <div className={css.editModeWrapper}>
          <div className={css.portalHeadingText} data-testid="portalDashboardText">
            {projectId ? t("Project Dashboard") : t("Portal Dashboard")}
          </div>
          <div className={css.lockUnlock} data-testid="lockUnlockIcon">
            {getLockUnlockIconRender()}
          </div>
          {!isStatic && (
            <div className={css.defaultButton} data-testid="portalDashboardSetLayoutToDefaultBtn">
              <ButtonComponent
                buttonType={BUTTON_TYPES.BORDER_BUTTON}
                bgColor="var(--surface-neutral)"
                onClick={defaultLayoutFunction}
              >
                {t("Set Layout to Default")}
              </ButtonComponent>
            </div>
          )}
          {["development"].includes(process.env.REACT_APP_ENV) && (
            <>
              <ButtonComponent
                buttonType={BUTTON_TYPES.BORDER_BUTTON}
                bgColor="var(--surface-neutral)"
                onClick={handleSignClick}
              >
                {t("Sign")}
              </ButtonComponent>
              <div className="hidden">
                <form id="signForm" target="_blank" action="" method="POST">
                  <input id="Parameter1" name="Parameter1" type="hidden" value="" />
                  <input id="Parameter2" name="Parameter2" type="hidden" value="" />
                  <input id="Parameter3" name="Parameter3" type="hidden" value="" />
                  <input type="submit" value="GatewayRedirect" />
                </form>
              </div>
            </>
          )}
        </div>
        <div className={css.WidgetModalWrapper} data-testid="widgetModalWrapperIcon">
          <div
            className={themeContext.themeType == THEME_LIGHT ? css.square : css.squareDark}
            onClick={openWidgetModal}
            data-testid="portalWidgetModalWrapper"
          >
            <IconComponent name="squares" toolTipContent="Manage Widgets" position="bottom" />
          </div>
        </div>
      </div>
      <div className="pb-8 w-full">
        <Responsive
          rowHeight={80}
          className={!isStatic && border && css.layoutBorderDash}
          autoSize
          width={width}
          isDraggable={!isStatic}
          isResizable={!isStatic}
          margin={isStatic ? [30, 30] : [20, 20]}
          containerPadding={isStatic ? [0, 0] : [20, 20]}
          isBounded
          onLayoutChange={(layout, layouts) => layoutChangeFunction(layout, layouts)}
          layouts={{ lg: gridLayout }}
          breakpoints={{
            lg: 1200,
            md: 996,
            sm: 768,
            xs: 480,
            xxs: 0,
          }}
          cols={{
            lg: 12,
            md: 10,
            sm: 6,
            xs: 4,
            xxs: 2,
          }}
        >
          {Object.keys(widgetMapper).map((widgetName, index) => {
            const widget = widgetMapper[widgetName];
            if (widget.isAdded && widget.allowIn.includes(projectId ? "PROJECT" : "PORTAL")) {
              return (
                <div
                  data-testid={widgetName}
                  key={`${widgetName}_card_${index}`}
                  data-grid={{
                    ...widget.layout,
                    i: `${widgetName}_card_${index}`,
                  }}
                >
                  {getWidgetCard({
                    widget,
                    widgetName,
                    isModalVisible: false,
                  })}
                </div>
              );
            }
          })}
        </Responsive>
        {!Object.keys(widgetMapper).filter((widgetName) => widgetMapper[widgetName].isAdded).length && (
          <div className={css.noPortaldataWrapper}>
            <div className={css.noPortalDataImage}>
              <img
                height="200px"
                width="50%"
                src={noProjectdata}
                alt="No Previews to Show"
                className={css.noSpacesImg}
              />
            </div>
            <div className={css.noPortalDataText}>
              <span
                style={{
                  ontSize: "var(--size18)",
                  padding: "var(--size-10)",
                }}
              >
                No widgets added yet.
              </span>
              <span onClick={openWidgetModal} className={css.noPortalDataAdd}>
                {" "}
                Add Widgets
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
  const openWidgetModal = () => {
    setIsWidgetModalVisible(true);
  };
  const closeWidgetModal = () => {
    setIsWidgetModalVisible(false);
  };
  const maxWidgetCardContent = () => (
    <div
      className="h-full"
      style={{
        // height: '500px',
        display: "flex",
        alignItems: " center",
        justifyContent: "center",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        {modalData.component &&
          getWidgetCard({
            widget: modalData.widget,
            widgetName: modalData.widgetName,
            isModalVisible: modalData.isModalVisible,
          })}
      </div>
    </div>
  );

  return {
    dragListavailableData,
    dragListselectedData,
    widgetMapper,
    getLockUnlockIconRender,
    setWidgetMapper,
    fetchUserSettings,
    weatherDetails,
    getDate,
    refreshPage,
    defaultLayoutFunction,
    getResposiveGrid,
    maxWidgetCardContent,
    setDragListselectedData,
    setDragListavailableData,
    setWidgetDataFiltered,
    widgetDataFiltered,
    isStatic,
    isWidgetModalVisible,
    setIsWidgetModalVisible,
    openWidgetModal,
    closeWidgetModal,
    isConfigureModalVisible,
    setSaveWidget,
    borderFunction,
    setIsConfigureModalVisible,
    handleWidgetMapperChange,
    getWeatherDiv,
  };
};
export default useDashboard;
